export const employeeType = (type: string) => {
    return type === 'CANDIDATE' ? 'Candidato': 'Empleado';
}